import { withPopup } from '../lib/popup';

import GroupMembershipsStep from './GroupMembershipsStep';

export default withPopup(GroupMembershipsStep);
